module.exports = __FOREMAN_VENDOR__SEAMLESS_IMMUTABLE__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__SEAMLESS_IMMUTABLE__"
// module id = seamless-immutable
// module chunks = 32